/**
 * Cover décorative de la carte « Panda Panic » : une petite arène qui s'effondre
 * (tuiles + rochers qui tombent) surmontée d'une frimousse de panda roux, plus
 * quatre pastilles « écharpe » pour les quatre joueurs. Purement ornemental
 * (`aria-hidden` posé par GameCard) — aucune donnée réelle, aucun import du
 * chunk 3D (le hub ne doit jamais tirer three.js, spec 15 §5).
 */

/** Couleurs d'écharpe des 4 sièges (valeurs figées, PAS d'import du rendu 3D). */
const SEAT_DOTS = ['#f97316', '#38bdf8', '#a3e635', '#f472b6'];

export function PandaPanicCover() {
  return (
    <div className="flex h-28 items-center justify-center gap-4 rounded-lg border border-ink-600/40 bg-app/60">
      <svg viewBox="0 0 72 56" className="h-20 w-24" aria-hidden="true">
        {/* Rochers qui tombent */}
        <circle cx="16" cy="9" r="3.5" fill="var(--rp-ink-400, #94a3b8)" />
        <circle cx="52" cy="6" r="2.6" fill="var(--rp-ink-500, #64748b)" />
        <circle cx="40" cy="13" r="2" fill="var(--rp-ink-400, #94a3b8)" />
        {/* Plateforme en damier (deux rangées, une tuile qui se détache) */}
        <g>
          <rect x="10" y="34" width="14" height="10" rx="1.5" fill="var(--rp-panda-500, #f97316)" />
          <rect x="26" y="34" width="14" height="10" rx="1.5" fill="var(--rp-panda-600, #ea580c)" />
          <rect x="42" y="34" width="14" height="10" rx="1.5" fill="var(--rp-panda-500, #f97316)" />
          {/* Tuile qui bascule dans le vide */}
          <rect
            x="46"
            y="48"
            width="12"
            height="8"
            rx="1.5"
            fill="var(--rp-panda-600, #ea580c)"
            opacity="0.55"
            transform="rotate(14 52 52)"
          />
        </g>
        {/* Frimousse de panda roux */}
        <g transform="translate(26 16)">
          <circle cx="10" cy="10" r="9" fill="var(--rp-panda-500, #f97316)" />
          <circle cx="3.5" cy="3" r="3" fill="var(--rp-panda-600, #ea580c)" />
          <circle cx="16.5" cy="3" r="3" fill="var(--rp-panda-600, #ea580c)" />
          <circle cx="6.5" cy="9" r="1.5" fill="#1f2937" />
          <circle cx="13.5" cy="9" r="1.5" fill="#1f2937" />
          <circle cx="10" cy="13" r="1.6" fill="#1f2937" />
        </g>
      </svg>
      <div className="flex flex-col gap-1.5" aria-hidden="true">
        {SEAT_DOTS.map((hex) => (
          <span
            key={hex}
            className="h-3.5 w-3.5 rounded-full border border-ink-600/50"
            style={{ backgroundColor: hex }}
          />
        ))}
      </div>
    </div>
  );
}
